import mapToObject from '../util/map-to-object';

const PerformanceMetricsProperties = [
  'Clicks',
  'Impressions',
  'CTR',
  'Conversions',
  'ConversionsCredit',
  'AverageCPC',
  'AverageCPM',
  'VideoViews',
  'ViewThroughRate',
  'AverageCPV',
  'TotalWatchTimeInMS',
  'AverageWatchTimePerImpression',
  'AverageWatchTimePerVideoView',
  'Reach',
  'VideoViewsAt25Percent',
  'VideoViewsAt50Percent',
  'VideoViewsAt75Percent',
  'CompletedVideoViews',
  'VideoCompletionRate',
  'AveragePosition',
  'CPA',
  'PartialConversionCPA',
  'ConversionRate',
  'PartialConversionRate',
  'AdvertiserReportedRevenue',
  'RevenueOnAdSpend',
  'Spend',
  'WebsiteCoverage',
  'ClickSharePercent',
  'TopImpressionRate',
  'AbsoluteTopImpressionRate',
  'ExactMatchImpressionSharePercent',
  'TopImpressionSharePercent',
  'AbsoluteTopImpressionSharePercent',
  'AllConversions',
  'AllConversionsCredit',
  'AllConversionRate',
  'AllPartialConversionRate',
  'AllConversionCPA',
  'AllPartialConversionCPA',
  'AllConversionRevenueOnAdSpend',
  'AllConversionAdvertiserReportedRevenue',
  'ViewThroughConversions',
  'ViewThroughConversionsCredit',
  'ViewThroughConversionsRevenue',
  'ViewThroughConversionsCPA',
  'ViewThroughPartialConversionsCPA',
  'ViewThroughConversionsReturnOnAdSpend',
  'ViewThroughConversionsRate',
  'ViewThroughPartialConversionsRate',
  'AverageCPS',
  'SalesCount',
  'Installs',
  'CostPerInstall',
  'RevenuePerInstall',
  // Conversion value rule columns
  'AdvertiserReportedRevenueAdjustment',
  'AllConversionAdvertiserReportedRevenueAdjustment',
  'ViewThroughConversionsRevenueAdjustment',
  'NewCustomerConversions',
  'NewCustomerConversionRate',
  'NewCustomerCPA',
  'NewCustomerRevenue',
  'NewCustomerRevenueOnAdSpend',
];

export default mapToObject(PerformanceMetricsProperties, property => `PerformanceMetrics/${property}`);
